/**
 * PRIME DESK — Custom JavaScript — Phase 2 Final
 * Theme: 156327608491 (Tinker)
 * Lifecycle fix: global resize listener persists for page lifetime.
 * Only ATC bar + its observers are destroyed/rebuilt on viewport change.
 * Vanilla JS only. No jQuery. No external dependencies.
 */

(function () {
  'use strict';

  /* --------------------------------------------------------
     UTILITIES
  -------------------------------------------------------- */
  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (e) { return null; }
  }

  function qsa(selector, scope) {
    try { return Array.from((scope || document).querySelectorAll(selector)); }
    catch (e) { return []; }
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(String(str || '')));
    return div.innerHTML;
  }

  var prefersReducedMotion = !!(
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  var INIT_KEY = 'pdInitialized';

  /* --------------------------------------------------------
     PRODUCT PAGE DETECTION
     Tinker: <main id="MainContent" data-template="product">
  -------------------------------------------------------- */
  function isProductPage() {
    var main = qs('#MainContent[data-template]');
    if (!main) return false;
    var tpl = main.getAttribute('data-template') || '';
    return tpl === 'product' || tpl.indexOf('product') === 0;
  }

  /* --------------------------------------------------------
     1. HEADER SCROLL STATE
     Tinker: header-component#header-component
  -------------------------------------------------------- */
  function initHeaderScroll() {
    var header = qs('header-component#header-component') ||
                 qs('#header-component') ||
                 qs('#header-group header');
    if (!header) return;

    var SCROLL_THRESHOLD = 80;

    if ('IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;top:' + SCROLL_THRESHOLD +
        'px;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;';
      sentinel.setAttribute('aria-hidden', 'true');

      var insertTarget = header.parentNode || document.body;
      insertTarget.insertBefore(sentinel, header.nextSibling || insertTarget.firstChild);

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          header.classList.toggle('pd-scrolled', !entry.isIntersecting);
        });
      }, { threshold: 0 }).observe(sentinel);

    } else {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            header.classList.toggle('pd-scrolled', window.scrollY > SCROLL_THRESHOLD);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  }

  /* --------------------------------------------------------
     2. ACTIVE NAV LINK
     Tinker: header-menu .menu-list > li > .menu-list__link
  -------------------------------------------------------- */
  function initActiveNav() {
    var navLinks = qsa(
      'header-menu .menu-list > .menu-list__list-item > .menu-list__link'
    );
    if (!navLinks.length) return;

    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    navLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      var linkPath = href.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
      var isActive = (linkPath === currentPath) ||
        (linkPath !== '' && linkPath !== '/' && currentPath.indexOf(linkPath) === 0);
      link.classList.toggle('pd-active', isActive);
    });
  }

  /* --------------------------------------------------------
     3. ACCORDIONS
  -------------------------------------------------------- */
  function initAccordions(scope) {
    var triggers = qsa('.prime-accordion__trigger', scope || document);
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger[INIT_KEY]) return;
      trigger[INIT_KEY] = true;

      if (!trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function () {
        var isActive = trigger.classList.contains('pd-active');
        var content = trigger.nextElementSibling;
        if (!content || !content.classList.contains('prime-accordion__content')) return;

        var parentAccordion = trigger.closest('.prime-accordion');
        if (parentAccordion) {
          qsa('.prime-accordion__trigger.pd-active', parentAccordion).forEach(function (other) {
            if (other === trigger) return;
            var otherContent = other.nextElementSibling;
            other.classList.remove('pd-active');
            other.setAttribute('aria-expanded', 'false');
            if (otherContent) otherContent.style.maxHeight = '0';
          });
        }

        if (isActive) {
          trigger.classList.remove('pd-active');
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = '0';
        } else {
          trigger.classList.add('pd-active');
          trigger.setAttribute('aria-expanded', 'true');
          var inner = content.querySelector('.prime-accordion__content-inner');
          content.style.maxHeight = (inner ? inner.scrollHeight : content.scrollHeight) + 'px';
        }
      });
    });
  }

  /* --------------------------------------------------------
     4. MOBILE STICKY ADD TO CART — FIXED LIFECYCLE

     Architecture:
     - _atc.resizeListenerAttached: set once, never removed
     - destroyATCBar(): removes only bar + its 2 observers
     - buildATCBar(): creates bar + its 2 observers
     - handleViewport(): decides build vs destroy based on width
     - initStickyATC(): attaches global resize listener ONCE

     Global resize listener is NEVER removed.
     Only the bar and its observers are destroyed/rebuilt.
  -------------------------------------------------------- */
  var _atc = {
    bar:                   null,
    atcObserver:           null,
    btnObserver:           null,
    resizeTimer:           null,
    resizeListenerAttached: false,
    built:                 false
  };

  function destroyATCBar() {
    // Disconnect ATC IntersectionObserver
    if (_atc.atcObserver) {
      _atc.atcObserver.disconnect();
      _atc.atcObserver = null;
    }
    // Disconnect native button MutationObserver
    if (_atc.btnObserver) {
      _atc.btnObserver.disconnect();
      _atc.btnObserver = null;
    }
    // Remove bar from DOM
    if (_atc.bar && _atc.bar.parentNode) {
      _atc.bar.parentNode.removeChild(_atc.bar);
      _atc.bar = null;
    }
    _atc.built = false;
    // NOTE: resizeListenerAttached is NOT touched here.
  }

  function getTinkerATCSelectors() {
    return {
      nativeBtn: qs('add-to-cart-component button.add-to-cart-button') ||
                 qs('product-form-component button[name="add"]') ||
                 qs('button.add-to-cart-button') ||
                 qs('button[name="add"]'),
      titleEl:   qs('a.contents[ref="productTitleLink"] [role="heading"]') ||
                 qs('[ref="productTitleLink"] [role="heading"]') ||
                 qs('.product-title') ||
                 qs('h1'),
      priceEl:   qs('product-price .price__regular .price') ||
                 qs('product-price .price-item--sale.price') ||
                 qs('product-price .price') ||
                 qs('.price__regular .price') ||
                 qs('.price-item--sale')
    };
  }

  function buildATCBar() {
    if (_atc.built) return; // already built — do not duplicate

    var sel = getTinkerATCSelectors();
    var nativeBtn = sel.nativeBtn;
    if (!nativeBtn) return; // fail safely

    var productTitle = sel.titleEl ? sel.titleEl.textContent.trim() : '';
    var productPrice = sel.priceEl ? sel.priceEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'prime-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Ajouter au panier rapide');
    bar.innerHTML =
      '<div class="prime-sticky-atc__info">' +
        '<p class="prime-sticky-atc__title">' + escapeHTML(productTitle) + '</p>' +
        '<p class="prime-sticky-atc__price">' + escapeHTML(productPrice) + '</p>' +
      '</div>' +
      '<button type="button" class="prime-sticky-atc__btn">' +
        'AJOUTER AU PANIER' +
      '</button>';

    document.body.appendChild(bar);
    _atc.bar = bar;
    _atc.built = true;

    var stickyBtn = qs('.prime-sticky-atc__btn', bar);

    // Sync disabled state
    function syncDisabled() {
      if (!stickyBtn) return;
      var disabled = nativeBtn.disabled ||
                     nativeBtn.getAttribute('aria-disabled') === 'true' ||
                     nativeBtn.classList.contains('disabled');
      stickyBtn.disabled = disabled;
      stickyBtn.style.opacity = disabled ? '0.5' : '';
      stickyBtn.style.cursor  = disabled ? 'not-allowed' : '';
    }
    syncDisabled();

    // MutationObserver on native button
    if ('MutationObserver' in window) {
      var btnObserver = new MutationObserver(syncDisabled);
      btnObserver.observe(nativeBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });
      _atc.btnObserver = btnObserver;
    }

    // Sticky button → trigger native button
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (nativeBtn.disabled) return;
        nativeBtn.click();
      });
    }

    // IntersectionObserver: show when native ATC is off-screen
    if ('IntersectionObserver' in window) {
      var atcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('pd-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      atcObserver.observe(nativeBtn);
      _atc.atcObserver = atcObserver;
    } else {
      bar.classList.add('pd-visible');
    }
  }

  function handleViewport() {
    var isMobile = window.innerWidth <= 768;
    if (isMobile && !_atc.built) {
      buildATCBar();
    } else if (!isMobile && _atc.built) {
      destroyATCBar(); // removes bar + observers only, NOT resize listener
    }
  }

  function initStickyATC() {
    if (!isProductPage()) return;

    // Initial check
    handleViewport();

    // Attach global resize listener ONCE for the lifetime of the page
    if (!_atc.resizeListenerAttached) {
      _atc.resizeListenerAttached = true;
      window.addEventListener('resize', function () {
        clearTimeout(_atc.resizeTimer);
        _atc.resizeTimer = setTimeout(handleViewport, 200);
      }, { passive: true });
    }
  }

  /* --------------------------------------------------------
     5. FADE-IN — PROGRESSIVE ENHANCEMENT
  -------------------------------------------------------- */
  function initFadeIn() {
    document.body.classList.add('pd-js-ready');

    if (prefersReducedMotion) {
      qsa('.prime-fade-in').forEach(function (el) {
        el.classList.add('pd-visible');
      });
      return;
    }

    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pd-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      qsa('.prime-fade-in').forEach(function (el) {
        fadeObserver.observe(el);
      });
    } else {
      qsa('.prime-fade-in').forEach(function (el) {
        el.classList.add('pd-visible');
      });
    }
  }

  /* --------------------------------------------------------
     6. THEME EDITOR SUPPORT
  -------------------------------------------------------- */
  function initThemeEditorSupport() {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (!section) return;

      initAccordions(section);

      if (!prefersReducedMotion && 'IntersectionObserver' in window) {
        var sectionFadeObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('pd-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

        qsa('.prime-fade-in', section).forEach(function (el) {
          el.classList.remove('pd-visible');
          sectionFadeObserver.observe(el);
        });
      } else {
        qsa('.prime-fade-in', section).forEach(function (el) {
          el.classList.add('pd-visible');
        });
      }

      // Product section reloaded: destroy bar + observers, rebuild after DOM settles
      // Global resize listener is preserved — initStickyATC checks the flag
      if (isProductPage()) {
        destroyATCBar();
        setTimeout(function () {
          handleViewport(); // respects current viewport width
        }, 150);
      }
    });

    document.addEventListener('shopify:section:unload', function () {
      if (isProductPage()) {
        destroyATCBar();
        // resize listener stays active
      }
    });
  }

  /* --------------------------------------------------------
     INIT
  -------------------------------------------------------- */
  function init() {
    initHeaderScroll();
    initActiveNav();
    initAccordions();
    initFadeIn();
    initStickyATC();
    initThemeEditorSupport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
